<template>
    <section v-if="email && reportStore.reports[email].isReportFetch">
        <ul class="nav nav-pills nav-justified">
            <li class="nav-item">
                <a class="nav-link active" id="summary_tab" data-toggle="pill" href="#summary" aria-expanded="false">
                    Credit Summary
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link " id="personal_tab" data-toggle="pill" href="#personal" aria-expanded="true">
                    Personal Information
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" id="accounts_tab" data-toggle="pill" href="#accounts" aria-expanded="false">
                    <p class="mb-0">
                        All Accounts ({{ reportStore.reports[email].report.accounts.length }})
                    </p>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" id="collections_tab" data-toggle="pill" href="#collections" aria-expanded="false">
                    <p class="mb-0">
                        Derogatory Accounts ({{ reportStore.reports[email].report.derogatories.length }})
                    </p>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" id="public_record_tab" data-toggle="pill" href="#public_records" aria-expanded="false">
                    <span>
                        Public Records ({{ reportStore.reports[email].report.listPublicRecords.length }})
                    </span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" id="late_payments_tab" data-toggle="pill" href="#late_payments" aria-expanded="false">
                    <p class="mb-0">
                        Late Payments ({{ reportStore.reports[email].report.latePayments.length }})
                    </p>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link " id="inquiries_tab" data-toggle="pill" href="#inquiries" aria-expanded="false">
                    <p class="mb-0">
                        Inquiries ({{ reportStore.reports[email].report.inquiries.length }})
                    </p>
                </a>
            </li>
        </ul>
        <div class="tab-content">
            <div  class="tab-pane active" role="tab-pane" id="summary" aria-labelledby="summary_tab" aria-expanded="true">
                <report-summary :email="email"></report-summary>
            </div>
            <div  class="tab-pane " role="tab-pane " id="personal" aria-labelledby="personal_tab" aria-expanded="true">
                <personal-information :email="email" />
            </div>
            <div class="tab-pane" role="tab-pane"  id="accounts" aria-labelledby="accounts_tab" aria-expanded="true">
                <account-history :email="email"></account-history>
            </div>
            <div class="tab-pane " role="tab-pane" id="inquiries" aria-labelledby="inquiries_tab" aria-expanded="true">
                <inquiry :email="email"></inquiry>
            </div>
            <div class="tab-pane" id="late_payments" role="tabpanel" aria-labelledby="late_payments_tab" aria-expanded="true">
                <late-payment :email="email"></late-payment>
            </div>
            <div class="tab-pane" id="collections" role="tabpanel" aria-labelledby="collections_tab" aria-expanded="true">
                <derogatory :email="email"></derogatory>
            </div>
            <div class="tab-pane" id="public_records" role="tabpanel" aria-labelledby="public_record_tab" aria-expanded="true">
                <public-record :email="email"></public-record>
            </div>
        </div>
    </section>
    <loading v-else />
</template>

<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import PersonalInformation from './PersonalInformation'
    import Loader from './Loader'
    export default {
        mounted() {
            if (_.isNull(this.email) && this.$route.params.client) {
                this.email = this.clientEmail;
            }
        },
        components: {
            'personal-information': PersonalInformation,
            'loading': Loader,
        },
        props: {
            clientEmail: {
                type: String,
                default: null
            }
        },
        setup() {
            return {
                reportStore: useReportStore(),
                userStore: useUserStore(),
                email: ref(null),
            }
        },
        watch: {
            'userStore.user'(value) {
                if (value != null) {
                    if (!value.isBusinessUser) {
                        this.email = value.email;
                    }
                    else {
                        if(_.isNull(this.email)){
                            this.email = value.email
                        }else{
                            this.email = this.clientEmail;
                        }
                    }
                    if (!this.reportStore.reports[this.email]) {
                        this.reportStore.getReport();
                    }
                }
            },
        },
        computed: {
        },
        mounted(){
            let value = this.userStore.user;
            if (value != null) {
                if (!value.isBusinessUser) {
                    this.email = value.email;
                }
                else {
                    if(_.isNull(this.email)){
                        this.email = value.email
                    }else{
                        this.email = this.clientEmail;
                    }
                }
                if (!this.reportStore.reports[this.email]) {
                    this.reportStore.getReport();
                }
            }
        }
    }
</script>
